<template>
  <div>
    <Header :title="$t('usr.title')" />
    <div class="full-page-box">
      <div class="usr-box">
        <p style="line-height: 1.4">{{ $t("usr.msg") }}</p>

        <van-form @submit="onSubmit">
          <van-cell-group>
            <van-divider>{{ $t("usr.title") }}</van-divider>
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Phone") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field disabled 
              class="input"
              v-model="Phone"
              :placeholder="$t('usr.Phonedesc')"
              :rules="[{ required: true }]"
            />
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Education") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="Education"
              :placeholder="$t('usr.Educationdesc')"
              :rules="[{ required: true }]"
            />
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Purpose") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="Purpose"
              :placeholder="$t('usr.Purposedesc')"
              :rules="[{ required: true }]"
            />
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.House") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              readonly
              clickable
              :value="House"
              :placeholder="$t('usr.Housedesc')"
              @click="showPickerhouse = true"
              :rules="[{ required: true }]"
              right-icon="arrow-down"
            />
            <van-popup v-model="showPickerhouse" round position="bottom">
              <van-picker
                show-toolbar
                :confirm-button-text="$t('common.confirm')"
                :cancel-button-text="$t('common.cancel')"
                :columns="yesornoHouse"
                @cancel="showPickerhouse = false"
                @confirm="onConfirmhouse"
              />
            </van-popup>
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Vehicle") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              readonly
              clickable
              :value="Vehicle"
              :placeholder="$t('usr.Vehicledesc')"
              @click="showPickerCar = true"
              :rules="[{ required: true }]"
              right-icon="arrow-down"
            />
            <van-popup v-model="showPickerCar" round position="bottom">
              <van-picker
                show-toolbar
                :confirm-button-text="$t('common.confirm')"
                :cancel-button-text="$t('common.cancel')"
                :columns="yesornoCar"
                @cancel="showPickerCar = false"
                @confirm="onConfirmcar"
              />
            </van-popup>
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Income") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="Income"
              :placeholder="$t('usr.Incomedesc')"
              :rules="[{ required: true }]"
            />
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Address") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="Address"
              :placeholder="$t('usr.Addressdesc')"
              :rules="[{ required: true }]"
            />

            <van-divider>{{ $t("usr.Family") }}</van-divider>
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Relationship") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              readonly
              clickable
              :value="FamilyRelationship"
              :placeholder="$t('usr.Relationship')"
              @click="showPickerRelationship = true"
              :rules="[{ required: true }]"
              right-icon="arrow-down"
            />
            <van-popup v-model="showPickerRelationship" round position="bottom">
              <van-picker
                show-toolbar
                :confirm-button-text="$t('common.confirm')"
                :cancel-button-text="$t('common.cancel')"
                :columns="relationshipFamily"
                @cancel="showPickerRelationship = false"
                @confirm="onConfirmfamily"
              />
            </van-popup>
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Name") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="FamilyName"
              :placeholder="$t('usr.Namedesc')"
              :rules="[{ required: true }]"
            />
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Phone") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="FamilyPhone"
              :placeholder="$t('usr.Phonedesc')"
              :rules="[{ required: true }]"
            />

            <van-divider>{{ $t("usr.other") }}</van-divider>
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Relationship") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              readonly
              clickable
              :value="OtherRelationship"
              :placeholder="$t('usr.Relationship')"
              @click="showPickerOther = true"
              :rules="[{ required: true }]"
              right-icon="arrow-down"
            />
            <van-popup v-model="showPickerOther" round position="bottom">
              <van-picker
                show-toolbar
                :confirm-button-text="$t('common.confirm')"
                :cancel-button-text="$t('common.cancel')"
                :columns="relationshipOther"
                @cancel="showPickerOther = false"
                @confirm="onConfirmother"
              />
            </van-popup>
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Name") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="OtherName"
              :placeholder="$t('usr.Namedesc')"
              :rules="[{ required: true }]"
            />
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("usr.Phone") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="OtherPhone"
              :placeholder="$t('usr.Phonedesc')"
              :rules="[{ required: true }]"
            />
          </van-cell-group>
          <div style="margin: 20px 0">
            <van-button
            v-if="!checkInfo()"
              block
              class="btn"
              native-type="submit"
              v-show="!isfinish"
              >{{ $t("common.confirm") }}</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Header from "@/components/header";
export default {
  name: "UsrInfo",
  components: { Header },
  data() {
    return {
      yesornoHouse: [this.$t("usr.no"), this.$t("usr.yes")],
      yesornoCar: [this.$t("usr.no"), this.$t("usr.yes")],

      relationshipFamily: [
        this.$t("usr.parents"),
        this.$t("usr.spouse"),
        this.$t("usr.brothers"),
        this.$t("usr.classmates"),
        this.$t("usr.friends"),
      ],

      relationshipOther: [
        this.$t("usr.parents"),
        this.$t("usr.spouse"),
        this.$t("usr.brothers"),
        this.$t("usr.classmates"),
        this.$t("usr.friends"),
      ],

      showPickerhouse: false,
      showPickerCar: false,
      showPickerRelationship: false,
      showPickerOther: false,

      Phone: null,
      Education: null,
      Purpose: null,
      House: null,
      Vehicle: null,
      Income: null,
      Address: null,

      FamilyRelationship: null,
      FamilyName: null,
      FamilyPhone: null,

      OtherRelationship: null,
      OtherName: null,
      OtherPhone: null,

      isfinish: false,
      usrdata:{}
    };
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ name: "login" });
    } else {
      this.getInfo()
    }
  },
  methods: {
    onSubmit() {
      this.$http({
        method: "post",
        data: {
          education: this.Education,
          purpose: this.Purpose,
          house: this.House,
          vehicle: this.Vehicle,
          income: this.Income,
          address: this.Address,
          relationship: this.FamilyRelationship,
          nameRelationship: this.FamilyName,
          relativesPhone: this.FamilyPhone,
          otherName: this.OtherName,
          otherPhone: this.OtherPhone,
          otherRelationship: this.OtherRelationship,
        },
        url: "setPersonalInfo",
      }).then((res) => {
        if (res.code == 200) {
          Toast(res.msg);
        } else {
          Toast(res.msg);
        }
      });
    },
    getInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.usrdata = res.data
            this.Phone = res.data.phone;
            this.Education = res.data.education;
            this.Purpose = res.data.purpose;
            this.House = res.data.house;
            this.Vehicle = res.data.vehicle;
            this.Income = res.data.income;
            this.Address = res.data.address;

            this.FamilyRelationship = res.data.relationship;
            this.FamilyName = res.data.nameRelationship;
            this.FamilyPhone = res.data.relativesPhone;

            this.OtherRelationship = res.data.otherRelationship;
            this.OtherName = res.data.otherName;
            this.OtherPhone = res.data.otherPhone;
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    checkInfo(){
        return (
            this.usrdata.education
            && this.usrdata.purpose
            && this.usrdata.house
            && this.usrdata.vehicle
            && this.usrdata.income
            && this.usrdata.address
            && this.usrdata.relationship
            && this.usrdata.nameRelationship
            && this.usrdata.relativesPhone
            && this.usrdata.otherName
            && this.usrdata.otherPhone
            && this.usrdata.otherRelationship
            && this.usrdata.education.length > 0
            && this.usrdata.purpose.length > 0
            && this.usrdata.house.length > 0
            && this.usrdata.vehicle.length > 0
            && this.usrdata.income.toString().length > 0
            && this.usrdata.address.length > 0
            && this.usrdata.relationship.length > 0
            && this.usrdata.nameRelationship.length > 0
            && this.usrdata.relativesPhone.toString().length > 0
            && this.usrdata.otherName.length > 0
            && this.usrdata.otherPhone.toString().length > 0
            && this.usrdata.otherRelationship.length > 0
        )
    },
    onConfirmhouse(val) {
      this.House = val;
      this.showPickerhouse = false;
    },
    onConfirmcar(val) {
      this.Vehicle = val;
      this.showPickerCar = false;
    },
    onConfirmfamily(val) {
      this.FamilyRelationship = val;
      this.showPickerRelationship = false;
    },
    onConfirmother(val) {
      this.OtherRelationship = val;
      this.showPickerOther = false;
    },
  },
};
</script>
<style scoped>
.usr-box {
  width: 94%;
  margin: 10px auto;
}
.usr-box .input {
  border: 1px solid rgb(4 109 181) !important;
  border-radius: 8px;
}
.usr-box .btn {
  border: 1px solid rgb(4 109 181) !important;
  background-color: rgb(4 109 181);
  color: #fff;
  border-radius: 8px;
}
</style>
